var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopUpCardOptionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.634,
    height: 51.634,
    viewBox: "0 0 51.634 51.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.608,28.931a1.6,1.6,0,0,1-1.14-.473,1.623,1.623,0,0,1,0-2.28L26.177.468a1.613,1.613,0,0,1,2.28,2.28L2.748,28.479A1.629,1.629,0,0,1,1.608,28.931Z",
    transform: "translate(6.847 6.847)",
    fill: "#f0a13d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.608,5.8A1.6,1.6,0,0,1,.468,5.33a1.623,1.623,0,0,1,0-2.28L3.05.468A1.613,1.613,0,1,1,5.33,2.748L2.748,5.33A1.612,1.612,0,0,1,1.608,5.8Z",
    transform: "translate(22.273 35.138)",
    fill: "#f0a13d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.608,8.364A1.6,1.6,0,0,1,.468,7.89a1.623,1.623,0,0,1,0-2.28L5.61.468a1.613,1.613,0,0,1,2.28,2.28L2.748,7.89A1.65,1.65,0,0,1,1.608,8.364Z",
    transform: "translate(28.06 26.79)",
    fill: "#f0a13d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M21.181,46.245c-2.108,0-4.217-1.291-6.777-3.851L3.84,31.83C-1.3,26.688-1.28,23.375,3.9,18.19L18.19,3.9c5.185-5.185,8.5-5.206,13.64-.065L42.394,14.4c5.142,5.142,5.12,8.455-.065,13.64L28.044,42.329C25.441,44.932,23.311,46.245,21.181,46.245ZM25.053,3.216c-1.119,0-2.539.925-4.583,2.969L6.185,20.471c-2.044,2.044-2.969,3.464-2.969,4.561,0,1.119.861,2.474,2.9,4.518L16.684,40.113c2.044,2.044,3.378,2.9,4.5,2.9H21.2c1.119,0,2.517-.925,4.561-2.969L40.049,25.763c2.044-2.044,2.969-3.464,2.969-4.561,0-1.119-.861-2.474-2.9-4.518L29.55,6.121C27.527,4.077,26.172,3.216,25.053,3.216Z",
    transform: "translate(2.7 2.7)",
    fill: "#f0a13d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M44.642,3.227H1.614A1.625,1.625,0,0,1,0,1.614,1.625,1.625,0,0,1,1.614,0H44.642a1.625,1.625,0,0,1,1.614,1.614A1.625,1.625,0,0,1,44.642,3.227Z",
    transform: "translate(2.689 45.718)",
    fill: "#f0a13d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H51.634V51.634H0Z",
    fill: "none",
    opacity: 0
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUpCardOptionLogo);
export default __webpack_public_path__ + "static/media/TopUpCardOptionLogo.2494dece91ae38946a247a3115509f45.svg";
export { ForwardRef as ReactComponent };